export default Object.freeze({
  TOP_NOTICE_1: '즉시 지급인 경우 지급 시점 회원정보 기준으로 지급 됩니다.',
  TOP_NOTICE_2: '예약 지급인 경우 예약 발송시점 회원정보 기준으로 지급 됩니다.',
  TOP_NOTICE_3: '전체 회원은 지급 시점 설정한 일시 기준 순차 지급 됩니다.',
  TOP_NOTICE_4: '회원등급 평가 기간 발송설정하는 경우 지급대상이 상이 할 수 있습니다.',
  TAB_CONFIGURATION_LIST: '적립금설정관리',
  TAB_PAYMENT_LIST: '적립금 지급관리',
  TAB_ACCUMULATION_LIST: '적립금 적립/차감 조회',
  TABLE_TITLE: '기본 설정',
  TITLE_DISCLAIMER: '* 필수입력',
  TBODY_MALL: '쇼핑몰',
  TBODY_PAYMENT_SET: '지급설정',
  TBODY_PAYMENT_IMMEDIATELY: '즉시지급',
  TBODY_PAYMENT_IMMEDIATELY_NOT: '예약지급',
  TBODY_PAYMENT_PAYMENT_MEMBER: '지급 회원대상',
  TBODY_PAYMENT_PAYMENT_MEMBER_ALL: '전체회원',
  TBODY_PAYMENT_PAYMENT_MEMBER_CHOSE: '회원선택',
  TBODY_PAYMENT_PAYMENT_DETAIL_BTN: '지급 상세',
  TBODY_PAYMENT_PAYMENT_TARGET_BTN: '지급대상변경',
  PAYMENT_TARGET_CANCLE_BTN: '취소',
  PAYMENT_MEMBER_SELECT_GROUP_BTN: '회원등급/그룹 선택',
  PAYMENT_MEMBER_SELECT_BTN: '회원 조회',
  PAYMENT_EXCEL_BATCH_REGISTRATION: '엑셀 일괄등록',
  PAYMENT_MEMBER_DESCRIPTIONS_1_1: '회원',
  PAYMENT_MEMBER_DESCRIPTIONS_1_2: '명 선택되었습니다. (중복 회원 제외)',
  PAYMENT_MEMBER_DESCRIPTIONS_2: '휴면회원 및 탈퇴회원은 적립금 지급 대상에서 제외됩니다.',
  PAYMENT_MEMBER_DESCRIPTIONS_3: '예약발송인 경우 설정일과 발송일 회원대상이 일치하지 않을 수 있습니다.',
  PAYMENT_SET: '지급설정',
  PAYMENT_MOUNT: '지급 적립금',
  PAYMENT_MOUNT_PLACEHOLDER: '적립금을 입력하세요.',
  PAYMENT_MOUNT_DEXCRIPTION_1: '숫자만 입력 할 수 있습니다.',
  PAYMENT_MOUNT_DEXCRIPTION_2: '적립금은 10원 단위로 입력 가능합니다.',
  IS_NUMBER: '입력형식이 잘못되었습니다.',
  PAYMENT_REASON: '지급 사유',
  PAYMENT_REASON_PLACEHOLDER: '지급 사유를 입력하세요.',
  PAYMENT_REASON_DEXCRIPTION: '몰 회원 적립금 지급 사유 표기되는 항목에 작성한 지급사유가 노출됩니다.',
  PAYMENT_VALIDPERIOD: '유효기간설정',
  PAYMENT_VALIDPERIOD_BASE: '기본 유효기간에 따름',
  PAYMENT_VALIDPERIOD_SET: '별도유효기간 지정',
  PAYMENT_VALIDPERIOD_SET_TITEL: '적립금 지급일 기준',
  PAYMENT_VALIDPERIOD_SET_YEAR: '년',
  PAYMENT_VALIDPERIOD_SET_MONTH: '개월',
  PAYMENT_VALIDPERIOD_DEXCRIPTION_1: '월단위 유효기간을 설정 하실 수 있습니다.',
  PAYMENT_VALIDPERIOD_DEXCRIPTION_2: '일단위 유효기간 지급은 회원관리>회원조회 메뉴에서 지급하실 수 있습니다.',
  PAYMENT_NOTIFICATION: '지급알림 설정',
  PAYMENT_NOTIFICATION_NOT_SET: '설정안함',
  PAYMENT_NOTIFICATION_SET: '설정함',
  PAYMENT_NOTIFICATION_STATUS_ALL: '전체선택',
  PAYMENT_NOTIFICATION_STATUS_KAKAOL: '카카오알림톡',
  PAYMENT_NOTIFICATION_STATUS_SMS: 'SMS',
  PAYMENT_NOTIFICATION_STATUS_EMAIL: '이메일',
  PAYMENT_NOTIFICATION_CONFIGER_TITLE: '지급알림 수단설정',
  PAYMENT_NOTIFICATION_TIME: '지급알림 시간설정',
  PAYMENT_NOTIFICATION_TIME_DEXCRIPTION: '설정한 알림수단을 사용처리 해야 정상 발송될 수 있습니다.',
  PAYMENT_SAVE: '적립금 지급하기',
  PAYMENT_KEEP: '저장',
  PAYMENT_CANCEL: '취소',
  PAYMENT_DELETE: '적립금 지급취소',
  PAYMENT_DELETE_COMFIRM: '취소하시면 적립금 예약 지급이 취소처리 됩니다. 취소하시겠습니까?',
  PAYMENT_CANCEL_ALERT: '작성한 내용을 취소하시겠습니까?',
  PAYMENT_CHANGE_BTN: '수정',
  PAYMENT_EXCLUDES_TITLE: '지급제외대상',
  PAYMENT_EXCLUDES_SET_NOT: '설정안함',
  PAYMENT_EXCLUDES_SET: '설정',
  PAYMENT_EXCLUDES_MEMBER_SEARCH: '회원 조회',
  PAYMENT_EXCLUDES_DEXCRIPTION_1_1: '지급 대상',
  PAYMENT_EXCLUDES_DEXCRIPTION_1_2: '명 중',
  PAYMENT_EXCLUDES_DEXCRIPTION_1_3: '명 지급 제외 선택 되었습니다.',
  PAYMENT_AMOUNT_ALERT: '적립금은 10원 단위로 입력 가능합니다.',
  PAYMENT_AMOUNT_OUT_MIN: '0 이상으로 입력해주세요.',
  PAYMENT_AMOUNT_OUT_MAX: '999,999,900 이하로 입력해주세요.',

  ADD_MALL_NO: '적립금을 지급할 쇼핑몰을 입력해주세요.',
  PAYMENT_TARGET_ALERT: '지급 회원대상을 선택해주세요.',
  PAYMENT_AMOUNT_ALERT_EMPTY: '지급 적립금을 입력해주세요.',
  ADD_REASON_ALERT_EMPTY: '지급사유를 입력해주세요.',
  ADD_NOTIFICATION_TIME_CHECK: '적립금 지급시간보다 지급알림을 과거 시간으로 설정할 수 없습니다.',
  PAYMENT_TIME_SET_OLD_TIME_ALERT: '적립금 지급시간을 과거 시간으로 설정할 수 없습니다.',
  ADD_NOTIFICATION_TIME_USELESS_ALERT: '유효하지 않은 알림시간 입니다.',
  NOTIFICATION_CHANNEL_EMPTY_ALERT: '알림수단을 선택해주세요.',
  VALIDPERIOD_ATLEAST_ONE_YEAR_ALERT: '적립금 유효기간은 최소 1개월이상 입니다.',
  FINISH_POST_PAYMENT: '적립금 지급이 완료 되었습니다.',
  FINISH_POST_PAYMENT1: '적립금 지급 예약이 설정 되었습니다.',
  CANCEL_POST_PAYMENT: '작성한 내용을 취소하시겠습니까?',
  DELETE_SUCESS_ALERT: '지급예약취소 성공했습니다.',
  MODIFY_SUCESS_ALERT: '적립금 지급 설정이 저장되었습니다.',
  MEMBER_SELECT_POPUP_TITLE: '회원등급/그룹 선택 팝업',
  MEMBER_SEARCH_POPUP_TITLE: '회원 조회 팝업',

  //엑셀 일괄 등록
  EXCEL_BATCH_REGISTRATION_TITLE: '지급 회원대상 일괄등록',
  MEMBER_NO: '회원번호',
  UPLOAD_FORM: '업로드 양식',
  BATCH_REGISTRATION_SAMPLE_DOWNLOAD: '일괄등록 샘플 다운로드',
  EXCEL_UPLOAD: '엑셀 업로드',
  EXCEL_BATCH_REGISTRATION_NOTICE_1: '일괄등록용 엑셀 다운로드 후 지급할 대상 회원의 회원번호를 입력 후 업로드하세요.',
  EXCEL_BATCH_REGISTRATION_NOTICE_2:
    '일괄등록용 엑셀 다운로드 파일에서 항목을 변경하는 경우 파일이 정상적으로 업로드되지 않습니다.',
  EXCEL_BATCH_REGISTRATION_NOTICE_3: '선택한 쇼핑몰의 가입완료 회원만 발급 대상 회원으로 선택 가능합니다.',
  EXCEL_BATCH_REGISTRATION_NOTICE_4: '일괄 등록 시 최대 1만건 까지 등록가능합니다.',
  WRONG_FILE_FORMAT: '잘못된 형식의 파일입니다.',
  NO_DATA: '엑셀파일을 등록해주세요.',
  INVALID_EXCEL_FILE: '엑셀 서식을 다시 확인해주세요.',
  MAXIMUM_LENGTH_TEN_THOUSAND: '1회 업로드시 최대 1만개까지 입력 가능 합니다.',
  MAXIMUM_FILE_SIZE_FIVE_MEGA_BYTE: '파일 크기는 5MB 이내로 첨부 가능합니다.',
  BATCH_REGISTRATION_EXCEL_SAMPLE: '대상 회원 일괄업로드 양식_{todayDate}.xlsx',
  SAVE_STATUS_ALERT: '저장되었습니다.\n 성공: {successCount}, 실패: {failCount}건',
  UPLOAD_FILE: '파일찾기',
  CANCEL: '취소',
  SAVE: '저장',
});
